import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  AccountWalletDetails,
  WalletBankAccountDetails,
  WalletTopUp,
  WalletTopupPaymentTypeEnum,
} from '@cai-services';

@Component({
  selector: 'kt-wallet-topup-payment-method',
  templateUrl: './wallet-topup-payment-method.component.html',
  styleUrls: ['./wallet-topup-payment-method.component.scss'],
  standalone: false,
})
export class WalletTopupPaymentMethodComponent implements OnChanges {
  @Input() walletTopUp: WalletTopUp = new WalletTopUp();
  @Input() walletDetails: AccountWalletDetails = new AccountWalletDetails();
  WalletTopupPaymentTypeEnum = WalletTopupPaymentTypeEnum;
  @Input() bankDetails: Array<WalletBankAccountDetails>;
  @Input() isCreditCardEnabled: boolean;
  @Input() isLocalEnabled: boolean;
  @Input() isInternationEnabled: boolean;
  @Input() isOtherEnabled: boolean;
  @Output() paymentTypeChanged = new EventEmitter();
  selectedBank: WalletBankAccountDetails = new WalletBankAccountDetails();
  localBanksAllowedCurrency = ['EUR', 'USD', 'GBP', 'CAD'];
  paymentDetailsLabel: any = {
    LOCAL_BANK: {
      EUR: { acnumber: 'IBAN', acrouting: 'BIC' },
      USD: { acnumber: 'Account Number', acrouting: 'ACH Routing Number' },
      GBP: { acnumber: 'Account Number', acrouting: 'Sort Code' },
      CAD: { acnumber: 'Account Number', acrouting: 'Routing Code' },
      AUD: { acnumber: 'Account Number', acrouting: 'ACH Routing Number' },
    },
    INTERNATIONAL_BANK: {
      USD: { acnumber: 'IBAN', acrouting: 'BIC' },
      EUR: { acnumber: 'IBAN', acrouting: 'BIC' },
      GBP: { acnumber: 'IBAN', acrouting: 'BIC' },
      CAD: { acnumber: 'IBAN', acrouting: 'BIC' },
      AUD: { acnumber: 'IBAN', acrouting: 'BIC' },
    },
  };
  paymentMethodTooltip = `Your Payment Methods : <br/> <br/>
<b>Local Bank Transfer</b> : CargoWALLET supports local bank transfers in 17 currencies.<br/> <br/>
<b>International Bank Transfer</b> : CargoWALLET supports the SWIFT bank transfer in 34 currencies.<br/> <br/>
<b>Credit Card</b> : Available in most currencies.<br/> <br/>
<b>Other Methods</b> : Benefit from your local payment method in more than 40 countries.`;
  onSelectPaymentMethod(type: WalletTopupPaymentTypeEnum): void {
    this.walletTopUp.paymentMethod = type;
    this.paymentTypeChanged.emit(type);
    if (
      type !== WalletTopupPaymentTypeEnum.CREDIT_CARD &&
      type !== WalletTopupPaymentTypeEnum.OTHER
    ) {
      this.manageAccountDetails();
    }
  }
  ngOnChanges(): void {
    if (
      this.walletDetails?.provider === 'currencycloud' &&
      this.bankDetails?.length
    ) {
      if (
        !this.localBanksAllowedCurrency.includes(this.walletTopUp.currency) &&
        this.walletTopUp.paymentMethod == WalletTopupPaymentTypeEnum.LOCAL_BANK
      ) {
        this.walletTopUp.paymentMethod =
          WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK;
      } else if (
        this.walletTopUp.paymentMethod ==
        WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK
      ) {
        this.walletTopUp.paymentMethod = WalletTopupPaymentTypeEnum.LOCAL_BANK;
      }
      this.manageAccountDetails();
    }
  }
  get hasLocalBank(): boolean {
    return this.bankDetails?.some((r) => !r.payment_type.includes('priority'));
  }
  get hasInternationalBank(): boolean {
    return this.bankDetails?.some((r) => r.payment_type.includes('priority'));
  }
  manageAccountDetails(): void {
    if (this.walletDetails?.provider === 'currencycloud') {
      if (
        this.bankDetails &&
        this.bankDetails.length &&
        this.walletTopUp.currency
      ) {
        this.selectedBank = this.bankDetails.find(
          (x) =>
            x.payment_type.includes('priority') ===
            (this.walletTopUp.paymentMethod ===
              WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK),
        );
        if (!this.selectedBank) {
          if (!this.hasLocalBank) {
            if (this.hasInternationalBank) {
              this.walletTopUp.paymentMethod =
                WalletTopupPaymentTypeEnum.INTERNATIONAL_BANK;
              this.manageAccountDetails();
            } else {
              this.walletTopUp.paymentMethod = null;
            }
          }

          new WalletBankAccountDetails();
        }
        this.walletTopUp.funding_account = this.selectedBank;
      }
    }
  }
  get isTazaPay(): boolean {
    return this.walletDetails?.provider === 'tazapay';
  }
}
